export interface UserRole {
  id: string;
  name: string;
  level: number;
  type: string;
}
export interface checkboxRole extends UserRole {
  active?: boolean;
}

export type CheckboxRole<T> = T & {
    active: boolean;
}

export enum InviteVerification {
    DIRECT_ACCESS = 'DIRECT_ACCESS',
    WITH_GRANT_ACCESS = 'WITH_GRANT_ACCESS',
}
